const preloaderReducer = (state = { loading: true }) => state;

export default preloaderReducer;
